import type { ResponseEventParams } from '@webapp/survey/src/entities/response-machine';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { ListApi } from './common/list';

export class OneOfListApi extends ListApi {
    public change({ answersActors, responseActor, id }: QuestionContext, evt: ResponseEventParams): void {
        const { answerId, value } = evt;
        responseActor.send({ type: 'CHANGE', questionId: id, value });

        if (value) {
            answersActors.forEach((answersActor) => {
                const otherAnswer = answersActor.getSnapshot().context;
                if (answerId !== otherAnswer.id) {
                    otherAnswer.response?.send({ type: 'SET', value: false });

                    if (otherAnswer.response.getSnapshot().context.extra) {
                        otherAnswer.response.send({ type: 'SET_EXTRA', value: '' });
                    }
                }
                if (!otherAnswer.valid) {
                    otherAnswer.valid = true;
                }
            });
        }
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { id, answersActors, responseActor } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;
        return {
            question: id,
            data: excludeHiddenAnswers(answersActors).map((answersActor) => {
                const { id, response: responseActor } = answersActor.getSnapshot().context;
                const response = responseActor.getSnapshot().context;
                const value = id === response.value || Boolean(response.value);
                return {
                    answer: id,
                    bool: value,
                    longtext: value && response.extra !== null ? String(response.extra) : undefined,
                };
            }),
            comment,
        };
    }

    public validate(context: QuestionContext): boolean {
        const {
            answersActors: answersActorsRaw,
            params: { required },
        } = context;
        if (!required) return true;
        const answersActors = excludeHiddenAnswers(answersActorsRaw);

        answersActors.forEach((answersActor) => {
            const a = answersActor.getSnapshot().context;
            const response = a.response.getSnapshot().context;
            if (!response.value) {
                // FIXME: Это че за дичь??
                a.valid = false;
            }
        });

        return answersActors.some((answersActor) => {
            const a = answersActor.getSnapshot().context;
            const { response, type } = a;
            const { comment, extra, value } = response.getSnapshot().context;
            return !!value && (type === null || comment || extra);
        });
    }
}
